import { gql } from '@apollo/client'

export const BEGIN_REVIEW_EDIT_CURRENT_CLASSIFICATION = gql`
  mutation BeginReviewEditCurrentClassification($boxId: ID!) {
    beginReviewEditCurrentClassification(boxId: $boxId) {
      __typename
      ... on ClassificationBatch {
        upc
        originalUpc
        anchorWasReplaced
        requiresAnchorReplacement
        rejectedBoxIds
        boundingBoxes {
          id
          sourceImageUrl
          minX
          maxX
          minY
          maxY
          metaClass
          isHumanAdded
          isHumanDeleted
          isFlagged
          flagged {
            level
            moreInfo
            reasons {
              type
              reason
              resolved
            }
          }
          leasedById
          leasedAt
        }
      }
      ... on LeaseLockError {
        code
        message
        retryAfterMs
      }
      ... on NoItemsAvailableError {
        code
        message
      }
    }
  }
`
